/**
 * Thresholds for displaying toolbox buttons.
 */
export const THRESHOLDS = [
    {
        width: 1200,
        order: ['microphone', 'camera', 'chat', 'materials', 'raisehand', 'participants', 'desktop', 'tileview']
    },
    {
        width: 1030,
        order: ['microphone', 'camera', 'chat', 'materials', 'raisehand', 'participants', 'desktop']
    },
    {
        width: 850,
        order: ['microphone', 'camera', 'chat', 'materials', 'raisehand']
    },
    {
        width: 700,
        order: ['microphone', 'camera', 'chat', 'materials']
    },
    {
        width: 350,
        order: ['microphone', 'camera', 'chat']
    },
    {
        width: 300,
        order: ['microphone', 'camera']
    },
    {
        width: 200,
        order: ['microphone']
    }
];
export const NOT_APPLICABLE = 'N/A';
export const TOOLBAR_TIMEOUT = 4000;
export const DRAWER_MAX_HEIGHT = '80vh - 64px';
export const NOTIFY_CLICK_MODE = {
    ONLY_NOTIFY: 'ONLY_NOTIFY',
    PREVENT_AND_NOTIFY: 'PREVENT_AND_NOTIFY'
};
